import axios from "axios";
import { useEffect, useState } from "react";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
export const http = axios.create({ baseURL: `${BACKEND}/api` });

http.interceptors.request.use((c) => {
  const t = localStorage.getItem("sd_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

export const imgUrl = (u) => (!u ? "" : u.startsWith("/api") ? `${BACKEND}${u}` : u);

export const DEFAULT_SETTINGS = { whatsapp: "51980615838", instagram: "sdesigner.ag", pix_key: "", pix_holder: "Samuel Soares" };

export const waLink = (num, text) => {
  let n = (num || DEFAULT_SETTINGS.whatsapp).replace(/\D/g, "");
  if (!n.startsWith("55")) n = `55${n}`;
  return `https://wa.me/${n}?text=${encodeURIComponent(text || "Olá! Vim pelo site da S'Designer.")}`;
};

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" ");
  return e?.message || "Algo deu errado.";
};

const arr = (r) => (r.status === "fulfilled" && Array.isArray(r.value?.data) ? r.value.data : []);

export function useSiteData() {
  const [data, setData] = useState({ services: [], packs: [], portfolio: [], settings: DEFAULT_SETTINGS, loaded: false });
  useEffect(() => {
    if (!BACKEND) {
      setData((d) => ({ ...d, loaded: true }));
      return undefined;
    }
    Promise.allSettled(["services", "packs", "portfolio", "settings"].map((k) => http.get(`/${k}`))).then(([s, p, f, st]) => {
      setData({
        services: arr(s),
        packs: arr(p),
        portfolio: arr(f),
        settings: { ...DEFAULT_SETTINGS, ...(st.status === "fulfilled" ? st.value?.data : {}) },
        loaded: true,
      });
    });
    return undefined;
  }, []);
  return data;
}

export const priceLabel = (p, fallback = "Sob consulta") =>
  p?.price || (p?.price_value > 0 ? p.price_value.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) : fallback);

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -70 });
  else el.scrollIntoView({ behavior: "smooth" });
};
